import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({ sra, setSra, setStep, storedUser }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    if (isEmpty(data.name)) {
      newErrors.name = "Vendor Name is required";
    }

    if (isEmpty(data.number)) {
      newErrors.number = "Number is required";
    }

    if (isEmpty(data.address)) {
      newErrors.address = "Address is required";
    }

    if (isEmpty(data.purpose)) {
      newErrors.purpose = "Purpose of the Deposit are required";
    } else if (data.purpose.length > 250) {
      newErrors.purpose = "Purpose of the Deposit must be up to 250 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/draft-customer-deposit`,
        {
          username: storedUser.username,
          title: sra.title,
          name: sra.name,
          number: sra.number,
          address: sra.address,
          purpose: sra.purpose,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSra(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-customer-deposit?draftSraId=${sra.draftCustomerDepositId}`,
        {
          title: sra.title,
          name: sra.name,
          number: sra.number,
          address: sra.address,
          purpose: sra.purpose,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Security Deposit Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="name">
              Name <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.name && "input-error"}`}
              type="text"
              name="name"
              id="name"
              onChange={handleChange}
              value={sra?.name || ""}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="number">
              Contact Number <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.number && "input-error"}`}
              type="text"
              name="number"
              id="number"
              onChange={handleChange}
              value={sra?.number || ""}
            />
            {errors.number && <p className="error">{errors.number}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="address">
              Address <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.address && "input-error"}`}
              type="text"
              name="address"
              id="address"
              onChange={handleChange}
              value={sra?.address || ""}
            />
            {errors.address && <p className="error">{errors.address}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="purpose">
              Purpose of the Deposit <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.purpose && "input-error"}`}
              type="text"
              name="purpose"
              id="purpose"
              onChange={handleChange}
              value={sra?.purpose || ""}
              rows={4}
            />
            {errors.purpose && <p className="error">{errors.purpose}</p>}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={sra && sra.draftCustomerDepositId ? handleUpdate : handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
